import { styled } from "theme/default/styled";
import { setFlexDFFDC } from "theme/setter/setFlexValues/setFlexDFFDC";

export const SSupportPageFeedbackFormForm = styled.form`
  width: 500px;

  ${setFlexDFFDC};
`;
